import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-mail",
  "use": "icon-si-glyph-mail-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-mail\" id=\"icon-si-glyph-mail\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1001</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M16.304,3.059 L1.701,3.059 C1.344,3.059 1.053,3.35 1.053,3.707 L1.053,12.324 C1.053,12.681 1.344,12.972 1.701,12.972 L16.304,12.972 C16.662,12.972 16.953,12.681 16.953,12.324 L16.953,3.707 C16.953,3.35 16.662,3.059 16.304,3.059 L16.304,3.059 Z M14.906,12.046 L12.022,8.643 L9.013,11.188 L5.955,8.57 L3.093,12.047 L1.847,12.047 L5.036,7.694 L1.966,5.094 L1.937,3.813 L9.013,9.344 L16.062,3.724 L16.062,5.094 L13.045,7.694 L16.169,12.032 L14.906,12.046 L14.906,12.046 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-mail.svg
// module id = xNGc
// module chunks = 62